import Konva from "konva";
import { Preloader } from "../../loader/Preloader";

export default class TextTransUI {
  constructor(group, rectShape) {
    const rect = rectShape.getClientRect();
    this.createDefault(group, rect);
    this.createScaleUI(group, rect);
    this.createMoveUI(group, rect);
    this.createRotUI(group, rect);
  }

  setupLayer(layer) {
    this.layer = layer;
  }

  createDefault(group, rect) {
    this.defaultUI = [];
    //白丸、消す。2020-01-31
    // for (let i = 0; i < 4; i++) {
    //   let { circle } = this.createCircle(
    //     0,
    //     i > 1 ? 0 : rect.height,
    //     "white",
    //     10
    //   );
    //   this.defaultUI.push(circle);
    //   group.add(circle);
    // }
  }

  createScaleUI(group, rect) {
    this.scaleUI = [];
    const rotTable = [0,90, 90, 0];

    for (let i = 0; i < 4; i++) {
      let y = i > 1 ? 0 : rect.height;
      let { circle, image } = this.createCircle(0, y, "#1e1e1e", 20, "scale");
      this.scaleUI.push(circle);
      group.add(circle);
      this.scaleUI.push(image);
      group.add(image);
      image.rotation(rotTable[i]);
    }
  }

  createMoveUI(group, rect) {
    this.moveUI = [];
    for (let i = 0; i < 4; i++) {
      let { circle } = this.createCircle(
        0,
        i > 1 ? 0 : rect.height,
        "#1e1e1e",
        10
      );
      this.moveUI.push(circle);
      group.add(circle);
    }


    let { circle, image } = this.createCircle(0, 0, "#1e1e1e", 20, "move");
    this.moveUI2 = [circle];
    group.add(circle);
    this.moveUI2.push(image);
    image.width(image.width() * 0.5);
    image.height(image.height() * 0.5);
    image.offsetX(image.width() * 0.5);
    image.offsetY(image.height() * 0.5);
    group.add(image);
  }

  createRotUI(group, rect) {
    const rotTable = [180, 270, 90, 0];
    this.rotUI = [];
    for (let i = 0; i < 4; i++) {
      let { circle, image } = this.createCircle(0, i > 1 ? 0 : rect.height, "#1e1e1e", 20, "rot");
      this.rotUI.push(circle);
      group.add(circle);
      this.rotUI.push(image);
      group.add(image);
      image.rotation(rotTable[i]);
    }
  }

  showMove() {
    this.moveUI.forEach(value => value.show());
    this.moveUI2.forEach(value => value.show());
    this.hideScale();
    this.hideRotation();
    this.hideTextInput();
    this.updateLayer();
  }

  showScale() {
    this.scaleUI.forEach(value => value.show());
    this.hideMove();
    this.hideRotation();
    this.hideTextInput();
    this.updateLayer();
  }

  showRotation() {
    this.rotUI.forEach(value => value.show());
    this.hideMove();
    this.hideScale();
    this.hideTextInput();
    this.updateLayer();
  }

  showTextInput() {
    this.defaultUI.forEach(value => value.show());
    this.hideMove();
    this.hideScale();
    this.hideRotation();
    this.updateLayer();
  }

  hideMove() {
    this.moveUI.forEach(value => value.hide());
    this.moveUI2.forEach(value => value.hide());
  }

  hideScale() {
    this.scaleUI.forEach(value => value.hide());
  }

  hideRotation() {
    this.rotUI.forEach(value => value.hide());
  }
  hideTextInput() {
    this.defaultUI.forEach(value => value.hide());
  }

  updateLayer() {
    if (this.layer) this.layer.draw();
  }

  createCircle(x = 0, y = 0, color = "white", radius = 20, fileName, callback) {
    const circle = new Konva.Circle({
      x: x,
      y: y,
      radius: radius,
      fill: color,
      stroke: "#0096ff",
      strokeWidth: 4
    });
    if (!fileName) return { circle };
    const image = this.createImage(x, y, fileName);

    return { circle, image };
  }
  createImage(x, y, fileName) {
    const img = Preloader.getImg(`/img/ui/text/${fileName}.png`);
    const w = img.width * 1 - 10;
    const h = img.width * 1 - 10;
    return new Konva.Image({
      x: x,
      y: y,
      width: w,
      height: h,
      offsetX: w * 0.5,
      offsetY: h * 0.5,
      image: img
    });
  }

  updateRect(rect) {
    this.moveUI2.forEach((value, index) => {
      // this._updateRectPos(rect, value, index);
      value.x(rect.width / 2);
      value.y(rect.height / 2);
    });
    this.moveUI.forEach((value, index) => {
      this._updateRectPos(rect, value, index, false);
    });
    this.scaleUI.forEach((value, index) => {
      this._updateRectPos(rect, value, index, true);
    });
    this.rotUI.forEach((value, index) => {
      this._updateRectPos(rect, value, index, true);
    });
    this.defaultUI.forEach((value, index) => {
      this._updateRectPos(rect, value, index, false);
    });
  }

  updateScale(scale) {
    this.moveUI.forEach((value, index) => {
      this._updateScale(value, scale);
    });
    this.moveUI2.forEach((value, index) => {
      this._updateScale(value, scale);
    });
    this.scaleUI.forEach((value, index) => {
      this._updateScale(value, scale);
    });
    this.rotUI.forEach((value, index) => {
      this._updateScale(value, scale);
    });
    this.defaultUI.forEach((value, index) => {
      this._updateScale(value, scale);
    });

  }
  _updateScale(value, scale) {
    value.scale({ x: 1/ scale, y: 1/scale });
  }


  _updateRectPos(rect, value, index, img) {

    let num = 1;
    if (img)
      num = 2;
    const num2 = num * 2;
    if (index % num2 < num) {
      value.x(rect.width);
    }
    if (index < num2) {
      value.y(rect.height);
    }
  }

  getCenter() {
    const ui = this.moveUI2[0];
    const pos = ui.absolutePosition();
    return pos;
  }
}
